'use strict';

var cov_th4vtqm2z = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\directives\\directives.js',
      hash = 'd47a5d903ec29dcf84fa145d0de344a9d2063f4a',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\directives\\directives.js',
    statementMap: {
      '0': {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 69,
          column: 4
        }
      },
      '1': {
        start: {
          line: 41,
          column: 23
        },
        end: {
          line: 66,
          column: 7
        }
      },
      '2': {
        start: {
          line: 43,
          column: 20
        },
        end: {
          line: 43,
          column: 46
        }
      },
      '3': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 49,
          column: 9
        }
      },
      '4': {
        start: {
          line: 46,
          column: 10
        },
        end: {
          line: 48,
          column: 11
        }
      },
      '5': {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 115
        }
      },
      '6': {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      '7': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 50
        }
      },
      '8': {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 57,
          column: 11
        }
      },
      '9': {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 56
        }
      },
      '10': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 66
        }
      },
      '11': {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 65,
          column: 11
        }
      },
      '12': {
        start: {
          line: 64,
          column: 10
        },
        end: {
          line: 64,
          column: 30
        }
      },
      '13': {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 52
        }
      },
      '14': {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      '15': {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 82,
          column: 9
        }
      },
      '16': {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 28
        }
      },
      '17': {
        start: {
          line: 85,
          column: 22
        },
        end: {
          line: 85,
          column: 38
        }
      },
      '18': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 89,
          column: 9
        }
      },
      '19': {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 116,
          column: 4
        }
      },
      '20': {
        start: {
          line: 101,
          column: 21
        },
        end: {
          line: 101,
          column: 28
        }
      },
      '21': {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 38
        }
      },
      '22': {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 106,
          column: 37
        }
      },
      '23': {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 114,
          column: 18
        }
      },
      '24': {
        start: {
          line: 110,
          column: 25
        },
        end: {
          line: 110,
          column: 39
        }
      },
      '25': {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 113,
          column: 71
        }
      },
      '26': {
        start: {
          line: 123,
          column: 2
        },
        end: {
          line: 148,
          column: 4
        }
      },
      '27': {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 141,
          column: 8
        }
      },
      '28': {
        start: {
          line: 130,
          column: 21
        },
        end: {
          line: 130,
          column: 49
        }
      },
      '29': {
        start: {
          line: 131,
          column: 21
        },
        end: {
          line: 131,
          column: 45
        }
      },
      '30': {
        start: {
          line: 132,
          column: 24
        },
        end: {
          line: 132,
          column: 53
        }
      },
      '31': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 33
        }
      },
      '32': {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 73
        }
      },
      '33': {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 58
        }
      },
      '34': {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 140,
          column: 15
        }
      },
      '35': {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 138,
          column: 24
        }
      },
      '36': {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 139,
          column: 43
        }
      },
      '37': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 146,
          column: 8
        }
      },
      '38': {
        start: {
          line: 144,
          column: 21
        },
        end: {
          line: 144,
          column: 49
        }
      },
      '39': {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 145,
          column: 22
        }
      },
      '40': {
        start: {
          line: 154,
          column: 2
        },
        end: {
          line: 171,
          column: 4
        }
      },
      '41': {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 169,
          column: 8
        }
      },
      '42': {
        start: {
          line: 161,
          column: 21
        },
        end: {
          line: 161,
          column: 49
        }
      },
      '43': {
        start: {
          line: 162,
          column: 23
        },
        end: {
          line: 162,
          column: 51
        }
      },
      '44': {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 54
        }
      },
      '45': {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 164,
          column: 67
        }
      },
      '46': {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 39
        }
      },
      '47': {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 168,
          column: 16
        }
      },
      '48': {
        start: {
          line: 167,
          column: 10
        },
        end: {
          line: 167,
          column: 38
        }
      },
      '49': {
        start: {
          line: 178,
          column: 2
        },
        end: {
          line: 203,
          column: 4
        }
      },
      '50': {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 196,
          column: 8
        }
      },
      '51': {
        start: {
          line: 185,
          column: 21
        },
        end: {
          line: 185,
          column: 49
        }
      },
      '52': {
        start: {
          line: 186,
          column: 21
        },
        end: {
          line: 186,
          column: 45
        }
      },
      '53': {
        start: {
          line: 187,
          column: 24
        },
        end: {
          line: 187,
          column: 53
        }
      },
      '54': {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 33
        }
      },
      '55': {
        start: {
          line: 190,
          column: 8
        },
        end: {
          line: 190,
          column: 73
        }
      },
      '56': {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 191,
          column: 58
        }
      },
      '57': {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 195,
          column: 15
        }
      },
      '58': {
        start: {
          line: 193,
          column: 10
        },
        end: {
          line: 193,
          column: 24
        }
      },
      '59': {
        start: {
          line: 194,
          column: 10
        },
        end: {
          line: 194,
          column: 43
        }
      },
      '60': {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 201,
          column: 8
        }
      },
      '61': {
        start: {
          line: 199,
          column: 21
        },
        end: {
          line: 199,
          column: 49
        }
      },
      '62': {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 200,
          column: 22
        }
      },
      '63': {
        start: {
          line: 210,
          column: 2
        },
        end: {
          line: 246,
          column: 4
        }
      },
      '64': {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 228,
          column: 8
        }
      },
      '65': {
        start: {
          line: 217,
          column: 21
        },
        end: {
          line: 217,
          column: 49
        }
      },
      '66': {
        start: {
          line: 218,
          column: 21
        },
        end: {
          line: 218,
          column: 45
        }
      },
      '67': {
        start: {
          line: 219,
          column: 24
        },
        end: {
          line: 219,
          column: 53
        }
      },
      '68': {
        start: {
          line: 220,
          column: 8
        },
        end: {
          line: 220,
          column: 33
        }
      },
      '69': {
        start: {
          line: 222,
          column: 8
        },
        end: {
          line: 222,
          column: 73
        }
      },
      '70': {
        start: {
          line: 223,
          column: 8
        },
        end: {
          line: 223,
          column: 58
        }
      },
      '71': {
        start: {
          line: 224,
          column: 8
        },
        end: {
          line: 227,
          column: 15
        }
      },
      '72': {
        start: {
          line: 225,
          column: 10
        },
        end: {
          line: 225,
          column: 24
        }
      },
      '73': {
        start: {
          line: 226,
          column: 10
        },
        end: {
          line: 226,
          column: 43
        }
      },
      '74': {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 233,
          column: 8
        }
      },
      '75': {
        start: {
          line: 231,
          column: 21
        },
        end: {
          line: 231,
          column: 49
        }
      },
      '76': {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 232,
          column: 22
        }
      },
      '77': {
        start: {
          line: 235,
          column: 6
        },
        end: {
          line: 244,
          column: 8
        }
      },
      '78': {
        start: {
          line: 236,
          column: 21
        },
        end: {
          line: 236,
          column: 49
        }
      },
      '79': {
        start: {
          line: 237,
          column: 23
        },
        end: {
          line: 237,
          column: 51
        }
      },
      '80': {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 238,
          column: 54
        }
      },
      '81': {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 239,
          column: 67
        }
      },
      '82': {
        start: {
          line: 240,
          column: 8
        },
        end: {
          line: 240,
          column: 39
        }
      },
      '83': {
        start: {
          line: 241,
          column: 8
        },
        end: {
          line: 243,
          column: 16
        }
      },
      '84': {
        start: {
          line: 242,
          column: 10
        },
        end: {
          line: 242,
          column: 38
        }
      },
      '85': {
        start: {
          line: 253,
          column: 2
        },
        end: {
          line: 279,
          column: 4
        }
      },
      '86': {
        start: {
          line: 257,
          column: 6
        },
        end: {
          line: 277,
          column: 8
        }
      },
      '87': {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 45
        }
      },
      '88': {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 276,
          column: 9
        }
      },
      '89': {
        start: {
          line: 261,
          column: 10
        },
        end: {
          line: 261,
          column: 33
        }
      },
      '90': {
        start: {
          line: 263,
          column: 10
        },
        end: {
          line: 266,
          column: 32
        }
      },
      '91': {
        start: {
          line: 265,
          column: 26
        },
        end: {
          line: 265,
          column: 54
        }
      },
      '92': {
        start: {
          line: 267,
          column: 15
        },
        end: {
          line: 276,
          column: 9
        }
      },
      '93': {
        start: {
          line: 268,
          column: 10
        },
        end: {
          line: 268,
          column: 33
        }
      },
      '94': {
        start: {
          line: 269,
          column: 10
        },
        end: {
          line: 272,
          column: 32
        }
      },
      '95': {
        start: {
          line: 271,
          column: 26
        },
        end: {
          line: 271,
          column: 54
        }
      },
      '96': {
        start: {
          line: 275,
          column: 10
        },
        end: {
          line: 275,
          column: 46
        }
      },
      '97': {
        start: {
          line: 283,
          column: 2
        },
        end: {
          line: 291,
          column: 4
        }
      },
      '98': {
        start: {
          line: 287,
          column: 6
        },
        end: {
          line: 289,
          column: 8
        }
      },
      '99': {
        start: {
          line: 288,
          column: 8
        },
        end: {
          line: 288,
          column: 45
        }
      },
      '100': {
        start: {
          line: 298,
          column: 2
        },
        end: {
          line: 333,
          column: 4
        }
      },
      '101': {
        start: {
          line: 304,
          column: 18
        },
        end: {
          line: 325,
          column: 8
        }
      },
      '102': {
        start: {
          line: 326,
          column: 25
        },
        end: {
          line: 328,
          column: 7
        }
      },
      '103': {
        start: {
          line: 327,
          column: 8
        },
        end: {
          line: 327,
          column: 25
        }
      },
      '104': {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 331,
          column: 9
        }
      },
      '105': {
        start: {
          line: 330,
          column: 8
        },
        end: {
          line: 330,
          column: 21
        }
      },
      '106': {
        start: {
          line: 340,
          column: 2
        },
        end: {
          line: 357,
          column: 4
        }
      },
      '107': {
        start: {
          line: 347,
          column: 6
        },
        end: {
          line: 349,
          column: 9
        }
      },
      '108': {
        start: {
          line: 348,
          column: 8
        },
        end: {
          line: 348,
          column: 17
        }
      },
      '109': {
        start: {
          line: 350,
          column: 6
        },
        end: {
          line: 352,
          column: 9
        }
      },
      '110': {
        start: {
          line: 351,
          column: 8
        },
        end: {
          line: 351,
          column: 17
        }
      },
      '111': {
        start: {
          line: 353,
          column: 21
        },
        end: {
          line: 355,
          column: 7
        }
      },
      '112': {
        start: {
          line: 354,
          column: 8
        },
        end: {
          line: 354,
          column: 66
        }
      },
      '113': {
        start: {
          line: 364,
          column: 2
        },
        end: {
          line: 393,
          column: 4
        }
      },
      '114': {
        start: {
          line: 368,
          column: 6
        },
        end: {
          line: 391,
          column: 9
        }
      },
      '115': {
        start: {
          line: 369,
          column: 22
        },
        end: {
          line: 369,
          column: 34
        }
      },
      '116': {
        start: {
          line: 371,
          column: 8
        },
        end: {
          line: 373,
          column: 11
        }
      },
      '117': {
        start: {
          line: 372,
          column: 10
        },
        end: {
          line: 372,
          column: 38
        }
      },
      '118': {
        start: {
          line: 375,
          column: 8
        },
        end: {
          line: 390,
          column: 11
        }
      },
      '119': {
        start: {
          line: 380,
          column: 10
        },
        end: {
          line: 384,
          column: 11
        }
      },
      '120': {
        start: {
          line: 381,
          column: 12
        },
        end: {
          line: 383,
          column: 15
        }
      },
      '121': {
        start: {
          line: 382,
          column: 14
        },
        end: {
          line: 382,
          column: 65
        }
      },
      '122': {
        start: {
          line: 385,
          column: 10
        },
        end: {
          line: 389,
          column: 11
        }
      },
      '123': {
        start: {
          line: 386,
          column: 12
        },
        end: {
          line: 388,
          column: 15
        }
      },
      '124': {
        start: {
          line: 387,
          column: 14
        },
        end: {
          line: 387,
          column: 50
        }
      },
      '125': {
        start: {
          line: 400,
          column: 2
        },
        end: {
          line: 408,
          column: 4
        }
      },
      '126': {
        start: {
          line: 406,
          column: 6
        },
        end: {
          line: 406,
          column: 46
        }
      },
      '127': {
        start: {
          line: 415,
          column: 2
        },
        end: {
          line: 457,
          column: 4
        }
      },
      '128': {
        start: {
          line: 418,
          column: 21
        },
        end: {
          line: 425,
          column: 7
        }
      },
      '129': {
        start: {
          line: 427,
          column: 28
        },
        end: {
          line: 441,
          column: 7
        }
      },
      '130': {
        start: {
          line: 429,
          column: 10
        },
        end: {
          line: 429,
          column: 28
        }
      },
      '131': {
        start: {
          line: 430,
          column: 10
        },
        end: {
          line: 432,
          column: 11
        }
      },
      '132': {
        start: {
          line: 431,
          column: 12
        },
        end: {
          line: 431,
          column: 43
        }
      },
      '133': {
        start: {
          line: 433,
          column: 10
        },
        end: {
          line: 435,
          column: 13
        }
      },
      '134': {
        start: {
          line: 434,
          column: 12
        },
        end: {
          line: 434,
          column: 35
        }
      },
      '135': {
        start: {
          line: 443,
          column: 6
        },
        end: {
          line: 443,
          column: 50
        }
      },
      '136': {
        start: {
          line: 445,
          column: 6
        },
        end: {
          line: 447,
          column: 9
        }
      },
      '137': {
        start: {
          line: 446,
          column: 8
        },
        end: {
          line: 446,
          column: 36
        }
      },
      '138': {
        start: {
          line: 449,
          column: 6
        },
        end: {
          line: 451,
          column: 8
        }
      },
      '139': {
        start: {
          line: 450,
          column: 8
        },
        end: {
          line: 450,
          column: 32
        }
      },
      '140': {
        start: {
          line: 453,
          column: 6
        },
        end: {
          line: 455,
          column: 8
        }
      },
      '141': {
        start: {
          line: 454,
          column: 8
        },
        end: {
          line: 454,
          column: 34
        }
      },
      '142': {
        start: {
          line: 464,
          column: 2
        },
        end: {
          line: 474,
          column: 4
        }
      },
      '143': {
        start: {
          line: 467,
          column: 6
        },
        end: {
          line: 472,
          column: 9
        }
      },
      '144': {
        start: {
          line: 468,
          column: 8
        },
        end: {
          line: 471,
          column: 11
        }
      },
      '145': {
        start: {
          line: 481,
          column: 2
        },
        end: {
          line: 497,
          column: 4
        }
      },
      '146': {
        start: {
          line: 484,
          column: 6
        },
        end: {
          line: 495,
          column: 9
        }
      },
      '147': {
        start: {
          line: 488,
          column: 26
        },
        end: {
          line: 488,
          column: 36
        }
      },
      '148': {
        start: {
          line: 490,
          column: 8
        },
        end: {
          line: 494,
          column: 9
        }
      },
      '149': {
        start: {
          line: 491,
          column: 10
        },
        end: {
          line: 491,
          column: 41
        }
      },
      '150': {
        start: {
          line: 493,
          column: 10
        },
        end: {
          line: 493,
          column: 42
        }
      },
      '151': {
        start: {
          line: 504,
          column: 2
        },
        end: {
          line: 514,
          column: 4
        }
      },
      '152': {
        start: {
          line: 507,
          column: 6
        },
        end: {
          line: 512,
          column: 9
        }
      },
      '153': {
        start: {
          line: 508,
          column: 8
        },
        end: {
          line: 511,
          column: 11
        }
      },
      '154': {
        start: {
          line: 521,
          column: 2
        },
        end: {
          line: 534,
          column: 4
        }
      },
      '155': {
        start: {
          line: 527,
          column: 6
        },
        end: {
          line: 532,
          column: 9
        }
      },
      '156': {
        start: {
          line: 528,
          column: 8
        },
        end: {
          line: 531,
          column: 11
        }
      },
      '157': {
        start: {
          line: 541,
          column: 2
        },
        end: {
          line: 572,
          column: 4
        }
      },
      '158': {
        start: {
          line: 547,
          column: 6
        },
        end: {
          line: 570,
          column: 9
        }
      },
      '159': {
        start: {
          line: 548,
          column: 24
        },
        end: {
          line: 548,
          column: 33
        }
      },
      '160': {
        start: {
          line: 549,
          column: 18
        },
        end: {
          line: 549,
          column: 40
        }
      },
      '161': {
        start: {
          line: 550,
          column: 18
        },
        end: {
          line: 550,
          column: 36
        }
      },
      '162': {
        start: {
          line: 551,
          column: 16
        },
        end: {
          line: 551,
          column: 17
        }
      },
      '163': {
        start: {
          line: 552,
          column: 8
        },
        end: {
          line: 564,
          column: 9
        }
      },
      '164': {
        start: {
          line: 553,
          column: 10
        },
        end: {
          line: 553,
          column: 14
        }
      },
      '165': {
        start: {
          line: 554,
          column: 22
        },
        end: {
          line: 554,
          column: 34
        }
      },
      '166': {
        start: {
          line: 555,
          column: 10
        },
        end: {
          line: 557,
          column: 11
        }
      },
      '167': {
        start: {
          line: 556,
          column: 12
        },
        end: {
          line: 556,
          column: 18
        }
      },
      '168': {
        start: {
          line: 559,
          column: 10
        },
        end: {
          line: 561,
          column: 11
        }
      },
      '169': {
        start: {
          line: 560,
          column: 12
        },
        end: {
          line: 560,
          column: 18
        }
      },
      '170': {
        start: {
          line: 562,
          column: 10
        },
        end: {
          line: 562,
          column: 20
        }
      },
      '171': {
        start: {
          line: 563,
          column: 10
        },
        end: {
          line: 563,
          column: 36
        }
      },
      '172': {
        start: {
          line: 565,
          column: 23
        },
        end: {
          line: 565,
          column: 77
        }
      },
      '173': {
        start: {
          line: 566,
          column: 8
        },
        end: {
          line: 569,
          column: 11
        }
      },
      '174': {
        start: {
          line: 579,
          column: 2
        },
        end: {
          line: 596,
          column: 4
        }
      },
      '175': {
        start: {
          line: 587,
          column: 6
        },
        end: {
          line: 594,
          column: 9
        }
      },
      '176': {
        start: {
          line: 588,
          column: 25
        },
        end: {
          line: 588,
          column: 43
        }
      },
      '177': {
        start: {
          line: 589,
          column: 24
        },
        end: {
          line: 589,
          column: 40
        }
      },
      '178': {
        start: {
          line: 590,
          column: 8
        },
        end: {
          line: 593,
          column: 11
        }
      },
      '179': {
        start: {
          line: 602,
          column: 2
        },
        end: {
          line: 607,
          column: 4
        }
      },
      '180': {
        start: {
          line: 605,
          column: 6
        },
        end: {
          line: 605,
          column: 28
        }
      },
      '181': {
        start: {
          line: 614,
          column: 2
        },
        end: {
          line: 622,
          column: 4
        }
      },
      '182': {
        start: {
          line: 617,
          column: 6
        },
        end: {
          line: 620,
          column: 9
        }
      },
      '183': {
        start: {
          line: 629,
          column: 2
        },
        end: {
          line: 635,
          column: 4
        }
      },
      '184': {
        start: {
          line: 632,
          column: 6
        },
        end: {
          line: 632,
          column: 55
        }
      },
      '185': {
        start: {
          line: 633,
          column: 6
        },
        end: {
          line: 633,
          column: 59
        }
      },
      '186': {
        start: {
          line: 642,
          column: 2
        },
        end: {
          line: 652,
          column: 4
        }
      },
      '187': {
        start: {
          line: 648,
          column: 6
        },
        end: {
          line: 650,
          column: 9
        }
      },
      '188': {
        start: {
          line: 649,
          column: 8
        },
        end: {
          line: 649,
          column: 49
        }
      },
      '189': {
        start: {
          line: 659,
          column: 2
        },
        end: {
          line: 672,
          column: 4
        }
      },
      '190': {
        start: {
          line: 665,
          column: 6
        },
        end: {
          line: 667,
          column: 9
        }
      },
      '191': {
        start: {
          line: 666,
          column: 8
        },
        end: {
          line: 666,
          column: 17
        }
      },
      '192': {
        start: {
          line: 668,
          column: 21
        },
        end: {
          line: 670,
          column: 7
        }
      },
      '193': {
        start: {
          line: 669,
          column: 8
        },
        end: {
          line: 669,
          column: 48
        }
      },
      '194': {
        start: {
          line: 679,
          column: 2
        },
        end: {
          line: 690,
          column: 4
        }
      },
      '195': {
        start: {
          line: 683,
          column: 6
        },
        end: {
          line: 688,
          column: 9
        }
      },
      '196': {
        start: {
          line: 686,
          column: 10
        },
        end: {
          line: 686,
          column: 48
        }
      },
      '197': {
        start: {
          line: 697,
          column: 2
        },
        end: {
          line: 710,
          column: 4
        }
      },
      '198': {
        start: {
          line: 700,
          column: 20
        },
        end: {
          line: 700,
          column: 43
        }
      },
      '199': {
        start: {
          line: 701,
          column: 26
        },
        end: {
          line: 701,
          column: 38
        }
      },
      '200': {
        start: {
          line: 702,
          column: 6
        },
        end: {
          line: 708,
          column: 9
        }
      },
      '201': {
        start: {
          line: 703,
          column: 8
        },
        end: {
          line: 707,
          column: 11
        }
      },
      '202': {
        start: {
          line: 704,
          column: 10
        },
        end: {
          line: 706,
          column: 11
        }
      },
      '203': {
        start: {
          line: 705,
          column: 12
        },
        end: {
          line: 705,
          column: 52
        }
      },
      '204': {
        start: {
          line: 716,
          column: 0
        },
        end: {
          line: 744,
          column: 49
        }
      }
    },
    fnMap: {
      '0': {
        name: 'pageTitle',
        decl: {
          start: {
            line: 38,
            column: 9
          },
          end: {
            line: 38,
            column: 18
          }
        },
        loc: {
          start: {
            line: 38,
            column: 41
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 38
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 41,
            column: 23
          },
          end: {
            line: 41,
            column: 24
          }
        },
        loc: {
          start: {
            line: 41,
            column: 82
          },
          end: {
            line: 66,
            column: 7
          }
        },
        line: 41
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 63,
            column: 17
          },
          end: {
            line: 63,
            column: 18
          }
        },
        loc: {
          start: {
            line: 63,
            column: 23
          },
          end: {
            line: 65,
            column: 9
          }
        },
        line: 63
      },
      '3': {
        name: 'sideNavigation',
        decl: {
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 75,
            column: 23
          }
        },
        loc: {
          start: {
            line: 75,
            column: 34
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 75
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 80,
            column: 15
          },
          end: {
            line: 80,
            column: 16
          }
        },
        loc: {
          start: {
            line: 80,
            column: 21
          },
          end: {
            line: 82,
            column: 7
          }
        },
        line: 80
      },
      '5': {
        name: 'responsiveVideo',
        decl: {
          start: {
            line: 97,
            column: 9
          },
          end: {
            line: 97,
            column: 24
          }
        },
        loc: {
          start: {
            line: 97,
            column: 27
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 97
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 109,
            column: 23
          },
          end: {
            line: 109,
            column: 24
          }
        },
        loc: {
          start: {
            line: 109,
            column: 29
          },
          end: {
            line: 114,
            column: 7
          }
        },
        line: 109
      },
      '7': {
        name: 'iboxTools',
        decl: {
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 122,
            column: 18
          }
        },
        loc: {
          start: {
            line: 122,
            column: 29
          },
          end: {
            line: 149,
            column: 1
          }
        },
        line: 122
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 129,
            column: 24
          },
          end: {
            line: 129,
            column: 25
          }
        },
        loc: {
          start: {
            line: 129,
            column: 36
          },
          end: {
            line: 141,
            column: 7
          }
        },
        line: 129
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 137,
            column: 17
          },
          end: {
            line: 137,
            column: 18
          }
        },
        loc: {
          start: {
            line: 137,
            column: 23
          },
          end: {
            line: 140,
            column: 9
          }
        },
        line: 137
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 143,
            column: 24
          },
          end: {
            line: 143,
            column: 25
          }
        },
        loc: {
          start: {
            line: 143,
            column: 36
          },
          end: {
            line: 146,
            column: 7
          }
        },
        line: 143
      },
      '11': {
        name: 'iboxToolsFullScreenOnly',
        decl: {
          start: {
            line: 153,
            column: 9
          },
          end: {
            line: 153,
            column: 32
          }
        },
        loc: {
          start: {
            line: 153,
            column: 43
          },
          end: {
            line: 172,
            column: 1
          }
        },
        line: 153
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 160,
            column: 26
          },
          end: {
            line: 160,
            column: 27
          }
        },
        loc: {
          start: {
            line: 160,
            column: 38
          },
          end: {
            line: 169,
            column: 7
          }
        },
        line: 160
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 166,
            column: 19
          },
          end: {
            line: 166,
            column: 20
          }
        },
        loc: {
          start: {
            line: 166,
            column: 25
          },
          end: {
            line: 168,
            column: 9
          }
        },
        line: 166
      },
      '14': {
        name: 'iboxCollapsable',
        decl: {
          start: {
            line: 177,
            column: 9
          },
          end: {
            line: 177,
            column: 24
          }
        },
        loc: {
          start: {
            line: 177,
            column: 35
          },
          end: {
            line: 204,
            column: 1
          }
        },
        line: 177
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 184,
            column: 24
          },
          end: {
            line: 184,
            column: 25
          }
        },
        loc: {
          start: {
            line: 184,
            column: 36
          },
          end: {
            line: 196,
            column: 7
          }
        },
        line: 184
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 192,
            column: 17
          },
          end: {
            line: 192,
            column: 18
          }
        },
        loc: {
          start: {
            line: 192,
            column: 23
          },
          end: {
            line: 195,
            column: 9
          }
        },
        line: 192
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 198,
            column: 24
          },
          end: {
            line: 198,
            column: 25
          }
        },
        loc: {
          start: {
            line: 198,
            column: 36
          },
          end: {
            line: 201,
            column: 7
          }
        },
        line: 198
      },
      '18': {
        name: 'iboxToolsFullScreen',
        decl: {
          start: {
            line: 209,
            column: 9
          },
          end: {
            line: 209,
            column: 28
          }
        },
        loc: {
          start: {
            line: 209,
            column: 39
          },
          end: {
            line: 247,
            column: 1
          }
        },
        line: 209
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 216,
            column: 24
          },
          end: {
            line: 216,
            column: 25
          }
        },
        loc: {
          start: {
            line: 216,
            column: 36
          },
          end: {
            line: 228,
            column: 7
          }
        },
        line: 216
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 224,
            column: 17
          },
          end: {
            line: 224,
            column: 18
          }
        },
        loc: {
          start: {
            line: 224,
            column: 23
          },
          end: {
            line: 227,
            column: 9
          }
        },
        line: 224
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 230,
            column: 24
          },
          end: {
            line: 230,
            column: 25
          }
        },
        loc: {
          start: {
            line: 230,
            column: 36
          },
          end: {
            line: 233,
            column: 7
          }
        },
        line: 230
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 235,
            column: 26
          },
          end: {
            line: 235,
            column: 27
          }
        },
        loc: {
          start: {
            line: 235,
            column: 38
          },
          end: {
            line: 244,
            column: 7
          }
        },
        line: 235
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 241,
            column: 19
          },
          end: {
            line: 241,
            column: 20
          }
        },
        loc: {
          start: {
            line: 241,
            column: 25
          },
          end: {
            line: 243,
            column: 9
          }
        },
        line: 241
      },
      '24': {
        name: 'minimalizaSidebar',
        decl: {
          start: {
            line: 252,
            column: 9
          },
          end: {
            line: 252,
            column: 26
          }
        },
        loc: {
          start: {
            line: 252,
            column: 37
          },
          end: {
            line: 280,
            column: 1
          }
        },
        line: 252
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 257,
            column: 26
          },
          end: {
            line: 257,
            column: 27
          }
        },
        loc: {
          start: {
            line: 257,
            column: 38
          },
          end: {
            line: 277,
            column: 7
          }
        },
        line: 257
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 264,
            column: 24
          },
          end: {
            line: 264,
            column: 25
          }
        },
        loc: {
          start: {
            line: 264,
            column: 30
          },
          end: {
            line: 266,
            column: 25
          }
        },
        line: 264
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 270,
            column: 24
          },
          end: {
            line: 270,
            column: 25
          }
        },
        loc: {
          start: {
            line: 270,
            column: 30
          },
          end: {
            line: 272,
            column: 25
          }
        },
        line: 270
      },
      '28': {
        name: 'closeOffCanvas',
        decl: {
          start: {
            line: 282,
            column: 9
          },
          end: {
            line: 282,
            column: 23
          }
        },
        loc: {
          start: {
            line: 282,
            column: 26
          },
          end: {
            line: 292,
            column: 1
          }
        },
        line: 282
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 287,
            column: 30
          },
          end: {
            line: 287,
            column: 31
          }
        },
        loc: {
          start: {
            line: 287,
            column: 42
          },
          end: {
            line: 289,
            column: 7
          }
        },
        line: 287
      },
      '30': {
        name: 'vectorMap',
        decl: {
          start: {
            line: 297,
            column: 9
          },
          end: {
            line: 297,
            column: 18
          }
        },
        loc: {
          start: {
            line: 297,
            column: 21
          },
          end: {
            line: 334,
            column: 1
          }
        },
        line: 297
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 326,
            column: 25
          },
          end: {
            line: 326,
            column: 26
          }
        },
        loc: {
          start: {
            line: 326,
            column: 37
          },
          end: {
            line: 328,
            column: 7
          }
        },
        line: 326
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 329,
            column: 28
          },
          end: {
            line: 329,
            column: 29
          }
        },
        loc: {
          start: {
            line: 329,
            column: 34
          },
          end: {
            line: 331,
            column: 7
          }
        },
        line: 329
      },
      '33': {
        name: 'sparkline',
        decl: {
          start: {
            line: 339,
            column: 9
          },
          end: {
            line: 339,
            column: 18
          }
        },
        loc: {
          start: {
            line: 339,
            column: 21
          },
          end: {
            line: 358,
            column: 1
          }
        },
        line: 339
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 347,
            column: 36
          },
          end: {
            line: 347,
            column: 37
          }
        },
        loc: {
          start: {
            line: 347,
            column: 42
          },
          end: {
            line: 349,
            column: 7
          }
        },
        line: 347
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 350,
            column: 39
          },
          end: {
            line: 350,
            column: 40
          }
        },
        loc: {
          start: {
            line: 350,
            column: 45
          },
          end: {
            line: 352,
            column: 7
          }
        },
        line: 350
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 353,
            column: 21
          },
          end: {
            line: 353,
            column: 22
          }
        },
        loc: {
          start: {
            line: 353,
            column: 33
          },
          end: {
            line: 355,
            column: 7
          }
        },
        line: 353
      },
      '37': {
        name: 'icheck',
        decl: {
          start: {
            line: 363,
            column: 9
          },
          end: {
            line: 363,
            column: 15
          }
        },
        loc: {
          start: {
            line: 363,
            column: 26
          },
          end: {
            line: 394,
            column: 1
          }
        },
        line: 363
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 368,
            column: 22
          },
          end: {
            line: 368,
            column: 23
          }
        },
        loc: {
          start: {
            line: 368,
            column: 28
          },
          end: {
            line: 391,
            column: 7
          }
        },
        line: 368
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 371,
            column: 38
          },
          end: {
            line: 371,
            column: 39
          }
        },
        loc: {
          start: {
            line: 371,
            column: 50
          },
          end: {
            line: 373,
            column: 9
          }
        },
        line: 371
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 379,
            column: 27
          },
          end: {
            line: 379,
            column: 28
          }
        },
        loc: {
          start: {
            line: 379,
            column: 36
          },
          end: {
            line: 390,
            column: 9
          }
        },
        line: 379
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 381,
            column: 26
          },
          end: {
            line: 381,
            column: 27
          }
        },
        loc: {
          start: {
            line: 381,
            column: 32
          },
          end: {
            line: 383,
            column: 13
          }
        },
        line: 381
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 386,
            column: 33
          },
          end: {
            line: 386,
            column: 34
          }
        },
        loc: {
          start: {
            line: 386,
            column: 39
          },
          end: {
            line: 388,
            column: 13
          }
        },
        line: 386
      },
      '43': {
        name: 'ionRangeSlider',
        decl: {
          start: {
            line: 399,
            column: 9
          },
          end: {
            line: 399,
            column: 23
          }
        },
        loc: {
          start: {
            line: 399,
            column: 26
          },
          end: {
            line: 409,
            column: 1
          }
        },
        line: 399
      },
      '44': {
        name: 'dropZone',
        decl: {
          start: {
            line: 414,
            column: 9
          },
          end: {
            line: 414,
            column: 17
          }
        },
        loc: {
          start: {
            line: 414,
            column: 20
          },
          end: {
            line: 458,
            column: 1
          }
        },
        line: 414
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 433,
            column: 23
          },
          end: {
            line: 433,
            column: 24
          }
        },
        loc: {
          start: {
            line: 433,
            column: 29
          },
          end: {
            line: 435,
            column: 11
          }
        },
        line: 433
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 445,
            column: 37
          },
          end: {
            line: 445,
            column: 38
          }
        },
        loc: {
          start: {
            line: 445,
            column: 57
          },
          end: {
            line: 447,
            column: 7
          }
        },
        line: 445
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 449,
            column: 30
          },
          end: {
            line: 449,
            column: 31
          }
        },
        loc: {
          start: {
            line: 449,
            column: 42
          },
          end: {
            line: 451,
            column: 7
          }
        },
        line: 449
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 453,
            column: 28
          },
          end: {
            line: 453,
            column: 29
          }
        },
        loc: {
          start: {
            line: 453,
            column: 40
          },
          end: {
            line: 455,
            column: 7
          }
        },
        line: 453
      },
      '49': {
        name: 'chatSlimScroll',
        decl: {
          start: {
            line: 463,
            column: 9
          },
          end: {
            line: 463,
            column: 23
          }
        },
        loc: {
          start: {
            line: 463,
            column: 34
          },
          end: {
            line: 475,
            column: 1
          }
        },
        line: 463
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 467,
            column: 15
          },
          end: {
            line: 467,
            column: 16
          }
        },
        loc: {
          start: {
            line: 467,
            column: 21
          },
          end: {
            line: 472,
            column: 7
          }
        },
        line: 467
      },
      '51': {
        name: 'customValid',
        decl: {
          start: {
            line: 480,
            column: 9
          },
          end: {
            line: 480,
            column: 20
          }
        },
        loc: {
          start: {
            line: 480,
            column: 23
          },
          end: {
            line: 498,
            column: 1
          }
        },
        line: 480
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 484,
            column: 34
          },
          end: {
            line: 484,
            column: 35
          }
        },
        loc: {
          start: {
            line: 484,
            column: 40
          },
          end: {
            line: 495,
            column: 7
          }
        },
        line: 484
      },
      '53': {
        name: 'fullScroll',
        decl: {
          start: {
            line: 503,
            column: 9
          },
          end: {
            line: 503,
            column: 19
          }
        },
        loc: {
          start: {
            line: 503,
            column: 30
          },
          end: {
            line: 515,
            column: 1
          }
        },
        line: 503
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 507,
            column: 15
          },
          end: {
            line: 507,
            column: 16
          }
        },
        loc: {
          start: {
            line: 507,
            column: 21
          },
          end: {
            line: 512,
            column: 7
          }
        },
        line: 507
      },
      '55': {
        name: 'slimScroll',
        decl: {
          start: {
            line: 520,
            column: 9
          },
          end: {
            line: 520,
            column: 19
          }
        },
        loc: {
          start: {
            line: 520,
            column: 30
          },
          end: {
            line: 535,
            column: 1
          }
        },
        line: 520
      },
      '56': {
        name: '(anonymous_56)',
        decl: {
          start: {
            line: 527,
            column: 15
          },
          end: {
            line: 527,
            column: 16
          }
        },
        loc: {
          start: {
            line: 527,
            column: 21
          },
          end: {
            line: 532,
            column: 7
          }
        },
        line: 527
      },
      '57': {
        name: 'slimScrollFull',
        decl: {
          start: {
            line: 540,
            column: 9
          },
          end: {
            line: 540,
            column: 23
          }
        },
        loc: {
          start: {
            line: 540,
            column: 34
          },
          end: {
            line: 573,
            column: 1
          }
        },
        line: 540
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 547,
            column: 15
          },
          end: {
            line: 547,
            column: 16
          }
        },
        loc: {
          start: {
            line: 547,
            column: 21
          },
          end: {
            line: 570,
            column: 7
          }
        },
        line: 547
      },
      '59': {
        name: 'slimScrollAfter',
        decl: {
          start: {
            line: 578,
            column: 9
          },
          end: {
            line: 578,
            column: 24
          }
        },
        loc: {
          start: {
            line: 578,
            column: 35
          },
          end: {
            line: 597,
            column: 1
          }
        },
        line: 578
      },
      '60': {
        name: '(anonymous_60)',
        decl: {
          start: {
            line: 587,
            column: 15
          },
          end: {
            line: 587,
            column: 16
          }
        },
        loc: {
          start: {
            line: 587,
            column: 21
          },
          end: {
            line: 594,
            column: 7
          }
        },
        line: 587
      },
      '61': {
        name: 'clockPicker',
        decl: {
          start: {
            line: 601,
            column: 9
          },
          end: {
            line: 601,
            column: 20
          }
        },
        loc: {
          start: {
            line: 601,
            column: 23
          },
          end: {
            line: 608,
            column: 1
          }
        },
        line: 601
      },
      '62': {
        name: 'landingScrollspy',
        decl: {
          start: {
            line: 613,
            column: 9
          },
          end: {
            line: 613,
            column: 25
          }
        },
        loc: {
          start: {
            line: 613,
            column: 28
          },
          end: {
            line: 623,
            column: 1
          }
        },
        line: 613
      },
      '63': {
        name: 'fitHeight',
        decl: {
          start: {
            line: 628,
            column: 9
          },
          end: {
            line: 628,
            column: 18
          }
        },
        loc: {
          start: {
            line: 628,
            column: 21
          },
          end: {
            line: 636,
            column: 1
          }
        },
        line: 628
      },
      '64': {
        name: 'truncate',
        decl: {
          start: {
            line: 641,
            column: 9
          },
          end: {
            line: 641,
            column: 17
          }
        },
        loc: {
          start: {
            line: 641,
            column: 28
          },
          end: {
            line: 653,
            column: 1
          }
        },
        line: 641
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 648,
            column: 15
          },
          end: {
            line: 648,
            column: 16
          }
        },
        loc: {
          start: {
            line: 648,
            column: 21
          },
          end: {
            line: 650,
            column: 7
          }
        },
        line: 648
      },
      '66': {
        name: 'touchSpin',
        decl: {
          start: {
            line: 658,
            column: 9
          },
          end: {
            line: 658,
            column: 18
          }
        },
        loc: {
          start: {
            line: 658,
            column: 21
          },
          end: {
            line: 673,
            column: 1
          }
        },
        line: 658
      },
      '67': {
        name: '(anonymous_67)',
        decl: {
          start: {
            line: 665,
            column: 38
          },
          end: {
            line: 665,
            column: 39
          }
        },
        loc: {
          start: {
            line: 665,
            column: 44
          },
          end: {
            line: 667,
            column: 7
          }
        },
        line: 665
      },
      '68': {
        name: '(anonymous_68)',
        decl: {
          start: {
            line: 668,
            column: 21
          },
          end: {
            line: 668,
            column: 22
          }
        },
        loc: {
          start: {
            line: 668,
            column: 33
          },
          end: {
            line: 670,
            column: 7
          }
        },
        line: 668
      },
      '69': {
        name: 'markdownEditor',
        decl: {
          start: {
            line: 678,
            column: 9
          },
          end: {
            line: 678,
            column: 23
          }
        },
        loc: {
          start: {
            line: 678,
            column: 26
          },
          end: {
            line: 691,
            column: 1
          }
        },
        line: 678
      },
      '70': {
        name: 'fileModel',
        decl: {
          start: {
            line: 696,
            column: 9
          },
          end: {
            line: 696,
            column: 18
          }
        },
        loc: {
          start: {
            line: 696,
            column: 27
          },
          end: {
            line: 711,
            column: 1
          }
        },
        line: 696
      },
      '71': {
        name: '(anonymous_71)',
        decl: {
          start: {
            line: 702,
            column: 29
          },
          end: {
            line: 702,
            column: 30
          }
        },
        loc: {
          start: {
            line: 702,
            column: 35
          },
          end: {
            line: 708,
            column: 7
          }
        },
        line: 702
      },
      '72': {
        name: '(anonymous_72)',
        decl: {
          start: {
            line: 703,
            column: 21
          },
          end: {
            line: 703,
            column: 22
          }
        },
        loc: {
          start: {
            line: 703,
            column: 27
          },
          end: {
            line: 707,
            column: 9
          }
        },
        line: 703
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }],
        line: 45
      },
      '1': {
        loc: {
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 48,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 48,
            column: 11
          }
        }, {
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 48,
            column: 11
          }
        }],
        line: 46
      },
      '2': {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 50
      },
      '3': {
        loc: {
          start: {
            line: 55,
            column: 10
          },
          end: {
            line: 57,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 55,
            column: 10
          },
          end: {
            line: 57,
            column: 11
          }
        }, {
          start: {
            line: 55,
            column: 10
          },
          end: {
            line: 57,
            column: 11
          }
        }],
        line: 55
      },
      '4': {
        loc: {
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        }, {
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        }],
        line: 259
      },
      '5': {
        loc: {
          start: {
            line: 259,
            column: 12
          },
          end: {
            line: 259,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 259,
            column: 12
          },
          end: {
            line: 259,
            column: 46
          }
        }, {
          start: {
            line: 259,
            column: 50
          },
          end: {
            line: 259,
            column: 82
          }
        }],
        line: 259
      },
      '6': {
        loc: {
          start: {
            line: 267,
            column: 15
          },
          end: {
            line: 276,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 267,
            column: 15
          },
          end: {
            line: 276,
            column: 9
          }
        }, {
          start: {
            line: 267,
            column: 15
          },
          end: {
            line: 276,
            column: 9
          }
        }],
        line: 267
      },
      '7': {
        loc: {
          start: {
            line: 380,
            column: 10
          },
          end: {
            line: 384,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 380,
            column: 10
          },
          end: {
            line: 384,
            column: 11
          }
        }, {
          start: {
            line: 380,
            column: 10
          },
          end: {
            line: 384,
            column: 11
          }
        }],
        line: 380
      },
      '8': {
        loc: {
          start: {
            line: 380,
            column: 14
          },
          end: {
            line: 380,
            column: 70
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 380,
            column: 14
          },
          end: {
            line: 380,
            column: 52
          }
        }, {
          start: {
            line: 380,
            column: 56
          },
          end: {
            line: 380,
            column: 70
          }
        }],
        line: 380
      },
      '9': {
        loc: {
          start: {
            line: 385,
            column: 10
          },
          end: {
            line: 389,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 385,
            column: 10
          },
          end: {
            line: 389,
            column: 11
          }
        }, {
          start: {
            line: 385,
            column: 10
          },
          end: {
            line: 389,
            column: 11
          }
        }],
        line: 385
      },
      '10': {
        loc: {
          start: {
            line: 385,
            column: 14
          },
          end: {
            line: 385,
            column: 67
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 385,
            column: 14
          },
          end: {
            line: 385,
            column: 49
          }
        }, {
          start: {
            line: 385,
            column: 53
          },
          end: {
            line: 385,
            column: 67
          }
        }],
        line: 385
      },
      '11': {
        loc: {
          start: {
            line: 430,
            column: 10
          },
          end: {
            line: 432,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 430,
            column: 10
          },
          end: {
            line: 432,
            column: 11
          }
        }, {
          start: {
            line: 430,
            column: 10
          },
          end: {
            line: 432,
            column: 11
          }
        }],
        line: 430
      },
      '12': {
        loc: {
          start: {
            line: 490,
            column: 8
          },
          end: {
            line: 494,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 490,
            column: 8
          },
          end: {
            line: 494,
            column: 9
          }
        }, {
          start: {
            line: 490,
            column: 8
          },
          end: {
            line: 494,
            column: 9
          }
        }],
        line: 490
      },
      '13': {
        loc: {
          start: {
            line: 555,
            column: 10
          },
          end: {
            line: 557,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 555,
            column: 10
          },
          end: {
            line: 557,
            column: 11
          }
        }, {
          start: {
            line: 555,
            column: 10
          },
          end: {
            line: 557,
            column: 11
          }
        }],
        line: 555
      },
      '14': {
        loc: {
          start: {
            line: 559,
            column: 10
          },
          end: {
            line: 561,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 559,
            column: 10
          },
          end: {
            line: 561,
            column: 11
          }
        }, {
          start: {
            line: 559,
            column: 10
          },
          end: {
            line: 561,
            column: 11
          }
        }],
        line: 559
      },
      '15': {
        loc: {
          start: {
            line: 704,
            column: 10
          },
          end: {
            line: 706,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 704,
            column: 10
          },
          end: {
            line: 706,
            column: 11
          }
        }, {
          start: {
            line: 704,
            column: 10
          },
          end: {
            line: 706,
            column: 11
          }
        }],
        line: 704
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

/**
 * INSPINIA - Responsive Admin Theme
 *
 * Main directives.js file
 * Define directives for used plugin
 *
 *
 * Functions (directives)
 *  - sideNavigation
 *  - iboxTools
 *  - minimalizaSidebar
 *  - vectorMap
 *  - sparkline
 *  - icheck
 *  - ionRangeSlider
 *  - dropZone
 *  - responsiveVideo
 *  - chatSlimScroll
 *  - customValid
 *  - fullScroll
 *  - closeOffCanvas
 *  - clockPicker
 *  - landingScrollspy
 *  - fitHeight
 *  - iboxToolsFullScreen
 *  - slimScroll
 *  - truncate
 *  - touchSpin
 *  - markdownEditor
 *  - resizeable
 *  - bootstrapTagsinput
 *
 */

/**
 * pageTitle - Directive for set Page title - mata title
 */
function pageTitle($rootScope, $timeout) {
  cov_th4vtqm2z.f[0]++;
  cov_th4vtqm2z.s[0]++;

  return {
    link: function link(scope, element) {
      cov_th4vtqm2z.s[1]++;

      var listener = function listener(event, toState, toParams, fromState, fromParams) {
        cov_th4vtqm2z.f[1]++;

        // Default title - load on Dashboard 1
        var title = (cov_th4vtqm2z.s[2]++, 'DELTA | Suivi-Evaluation');
        // Create your own title pattern
        cov_th4vtqm2z.s[3]++;
        if (fromState.data) {
          cov_th4vtqm2z.b[0][0]++;
          cov_th4vtqm2z.s[4]++;

          if (fromState.data.indexTrad) {
            cov_th4vtqm2z.b[1][0]++;
            cov_th4vtqm2z.s[5]++;

            $rootScope.addHistori({ indexTrad: fromState.data.indexTrad, id: fromState.name, icon: fromState.icon });
          } else {
            cov_th4vtqm2z.b[1][1]++;
          }
        } else {
          cov_th4vtqm2z.b[0][1]++;
        }
        cov_th4vtqm2z.s[6]++;
        if (toState.data) {
          cov_th4vtqm2z.b[2][0]++;
          cov_th4vtqm2z.s[7]++;

          // if(!$rootScope.checkExist()) return;

          $rootScope.islogin = toState.data.index;

          cov_th4vtqm2z.s[8]++;
          if (toState.data.pageTitle) {
            cov_th4vtqm2z.b[3][0]++;
            cov_th4vtqm2z.s[9]++;

            title = 'DELTA | ' + toState.data.pageTitle;
          } else {
            cov_th4vtqm2z.b[3][1]++;
          }
        } else {
          cov_th4vtqm2z.b[2][1]++;
        }
        cov_th4vtqm2z.s[10]++;
        $rootScope.$stateCls = toState.name.replace(/\./g, '-');
        /* $(document.body).removeClass(fromState.name.replace(/\./g,"-"));
         $(document.body).addClass(toState.name.replace(/\./g,"-")); */
        cov_th4vtqm2z.s[11]++;
        $timeout(function () {
          cov_th4vtqm2z.f[2]++;
          cov_th4vtqm2z.s[12]++;

          element.text(title);
        });
      };
      cov_th4vtqm2z.s[13]++;
      $rootScope.$on('$stateChangeStart', listener);
    }
  };
}

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
function sideNavigation($timeout) {
  cov_th4vtqm2z.f[3]++;
  cov_th4vtqm2z.s[14]++;

  return {
    restrict: 'A',
    link: function link(scope, element) {
      cov_th4vtqm2z.s[15]++;

      // Call the metsiMenu plugin and plug it to sidebar navigation
      $timeout(function () {
        cov_th4vtqm2z.f[4]++;
        cov_th4vtqm2z.s[16]++;

        element.metisMenu();
      });

      // Enable initial fixed sidebar
      var sidebar = (cov_th4vtqm2z.s[17]++, element.parent());
      cov_th4vtqm2z.s[18]++;
      sidebar.slimScroll({
        height: '100%',
        railOpacity: 0.9
      });
    }
  };
}

/**
 * responsibleVideo - Directive for responsive video
 */
function responsiveVideo() {
  cov_th4vtqm2z.f[5]++;
  cov_th4vtqm2z.s[19]++;

  return {
    restrict: 'A',
    link: function link(scope, element) {
      var figure = (cov_th4vtqm2z.s[20]++, element);
      var video = (cov_th4vtqm2z.s[21]++, element.children());
      cov_th4vtqm2z.s[22]++;
      video.attr('data-aspectRatio', video.height() / video.width()).removeAttr('height').removeAttr('width');

      // We can use $watch on $window.innerWidth also.
      cov_th4vtqm2z.s[23]++;
      $(window).resize(function () {
        cov_th4vtqm2z.f[6]++;

        var newWidth = (cov_th4vtqm2z.s[24]++, figure.width());
        cov_th4vtqm2z.s[25]++;
        video.width(newWidth).height(newWidth * video.attr('data-aspectRatio'));
      }).resize();
    }
  };
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxTools($timeout) {
  cov_th4vtqm2z.f[7]++;
  cov_th4vtqm2z.s[26]++;

  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'app/common/ibox_tools.html',
    controller: function controller($scope, $element) {
      cov_th4vtqm2z.s[27]++;

      // Function for collapse ibox
      $scope.showhide = function () {
        cov_th4vtqm2z.f[8]++;

        var ibox = (cov_th4vtqm2z.s[28]++, $element.closest('div.ibox'));
        var icon = (cov_th4vtqm2z.s[29]++, $element.find('i:first'));
        var content = (cov_th4vtqm2z.s[30]++, ibox.find('div.ibox-content'));
        cov_th4vtqm2z.s[31]++;
        content.slideToggle(200);
        // Toggle icon from up to down
        cov_th4vtqm2z.s[32]++;
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        cov_th4vtqm2z.s[33]++;
        ibox.toggleClass('').toggleClass('border-bottom');
        cov_th4vtqm2z.s[34]++;
        $timeout(function () {
          cov_th4vtqm2z.f[9]++;
          cov_th4vtqm2z.s[35]++;

          ibox.resize();
          cov_th4vtqm2z.s[36]++;
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      cov_th4vtqm2z.s[37]++;
      $scope.closebox = function () {
        cov_th4vtqm2z.f[10]++;

        var ibox = (cov_th4vtqm2z.s[38]++, $element.closest('div.ibox'));
        cov_th4vtqm2z.s[39]++;
        ibox.remove();
      };
    }
  };
}
/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
function iboxToolsFullScreenOnly($timeout) {
  cov_th4vtqm2z.f[11]++;
  cov_th4vtqm2z.s[40]++;

  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'app/common/ibox_tools_full_screen_only.html',
    controller: function controller($scope, $element) {
      cov_th4vtqm2z.s[41]++;

      // Function for full screen
      $scope.fullscreen = function () {
        cov_th4vtqm2z.f[12]++;

        var ibox = (cov_th4vtqm2z.s[42]++, $element.closest('div.ibox'));
        var button = (cov_th4vtqm2z.s[43]++, $element.find('i.fa-expand'));
        cov_th4vtqm2z.s[44]++;
        $('body').toggleClass('fullscreen-ibox-mode');
        cov_th4vtqm2z.s[45]++;
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        cov_th4vtqm2z.s[46]++;
        ibox.toggleClass('fullscreen');
        cov_th4vtqm2z.s[47]++;
        setTimeout(function () {
          cov_th4vtqm2z.f[13]++;
          cov_th4vtqm2z.s[48]++;

          $(window).trigger('resize');
        }, 100);
      };
    }
  };
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxCollapsable($timeout) {
  cov_th4vtqm2z.f[14]++;
  cov_th4vtqm2z.s[49]++;

  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'app/common/ibox_collasable.html',
    controller: function controller($scope, $element) {
      cov_th4vtqm2z.s[50]++;

      // Function for collapse ibox
      $scope.showhide = function () {
        cov_th4vtqm2z.f[15]++;

        var ibox = (cov_th4vtqm2z.s[51]++, $element.closest('div.ibox'));
        var icon = (cov_th4vtqm2z.s[52]++, $element.find('i:first'));
        var content = (cov_th4vtqm2z.s[53]++, ibox.find('div.ibox-content'));
        cov_th4vtqm2z.s[54]++;
        content.slideToggle(200);
        // Toggle icon from up to down
        cov_th4vtqm2z.s[55]++;
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        cov_th4vtqm2z.s[56]++;
        ibox.toggleClass('').toggleClass('border-bottom');
        cov_th4vtqm2z.s[57]++;
        $timeout(function () {
          cov_th4vtqm2z.f[16]++;
          cov_th4vtqm2z.s[58]++;

          ibox.resize();
          cov_th4vtqm2z.s[59]++;
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      cov_th4vtqm2z.s[60]++;
      $scope.closebox = function () {
        cov_th4vtqm2z.f[17]++;

        var ibox = (cov_th4vtqm2z.s[61]++, $element.closest('div.ibox'));
        cov_th4vtqm2z.s[62]++;
        ibox.remove();
      };
    }
  };
}

/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
function iboxToolsFullScreen($timeout) {
  cov_th4vtqm2z.f[18]++;
  cov_th4vtqm2z.s[63]++;

  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'app/common/ibox_tools_full_screen.html',
    controller: function controller($scope, $element) {
      cov_th4vtqm2z.s[64]++;

      // Function for collapse ibox
      $scope.showhide = function () {
        cov_th4vtqm2z.f[19]++;

        var ibox = (cov_th4vtqm2z.s[65]++, $element.closest('div.ibox'));
        var icon = (cov_th4vtqm2z.s[66]++, $element.find('i:first'));
        var content = (cov_th4vtqm2z.s[67]++, ibox.find('div.ibox-content'));
        cov_th4vtqm2z.s[68]++;
        content.slideToggle(200);
        // Toggle icon from up to down
        cov_th4vtqm2z.s[69]++;
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        cov_th4vtqm2z.s[70]++;
        ibox.toggleClass('').toggleClass('border-bottom');
        cov_th4vtqm2z.s[71]++;
        $timeout(function () {
          cov_th4vtqm2z.f[20]++;
          cov_th4vtqm2z.s[72]++;

          ibox.resize();
          cov_th4vtqm2z.s[73]++;
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      cov_th4vtqm2z.s[74]++;
      $scope.closebox = function () {
        cov_th4vtqm2z.f[21]++;

        var ibox = (cov_th4vtqm2z.s[75]++, $element.closest('div.ibox'));
        cov_th4vtqm2z.s[76]++;
        ibox.remove();
      };
      // Function for full screen
      cov_th4vtqm2z.s[77]++;
      $scope.fullscreen = function () {
        cov_th4vtqm2z.f[22]++;

        var ibox = (cov_th4vtqm2z.s[78]++, $element.closest('div.ibox'));
        var button = (cov_th4vtqm2z.s[79]++, $element.find('i.fa-expand'));
        cov_th4vtqm2z.s[80]++;
        $('body').toggleClass('fullscreen-ibox-mode');
        cov_th4vtqm2z.s[81]++;
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        cov_th4vtqm2z.s[82]++;
        ibox.toggleClass('fullscreen');
        cov_th4vtqm2z.s[83]++;
        setTimeout(function () {
          cov_th4vtqm2z.f[23]++;
          cov_th4vtqm2z.s[84]++;

          $(window).trigger('resize');
        }, 100);
      };
    }
  };
}

/**
 * minimalizaSidebar - Directive for minimalize sidebar
*/
function minimalizaSidebar($timeout) {
  cov_th4vtqm2z.f[24]++;
  cov_th4vtqm2z.s[85]++;

  return {
    restrict: 'A',
    template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
    controller: function controller($scope, $element) {
      cov_th4vtqm2z.s[86]++;

      $scope.minimalize = function () {
        cov_th4vtqm2z.f[25]++;
        cov_th4vtqm2z.s[87]++;

        $('body').toggleClass('mini-navbar');
        cov_th4vtqm2z.s[88]++;
        if ((cov_th4vtqm2z.b[5][0]++, !$('body').hasClass('mini-navbar')) || (cov_th4vtqm2z.b[5][1]++, $('body').hasClass('body-small'))) {
          cov_th4vtqm2z.b[4][0]++;
          cov_th4vtqm2z.s[89]++;

          // Hide menu in order to smoothly turn on when maximize menu
          $('#side-menu').hide();
          // For smoothly turn on menu
          cov_th4vtqm2z.s[90]++;
          setTimeout(function () {
            cov_th4vtqm2z.f[26]++;
            cov_th4vtqm2z.s[91]++;

            $('#side-menu').fadeIn(400);
          }, 200);
        } else {
            cov_th4vtqm2z.b[4][1]++;
            cov_th4vtqm2z.s[92]++;
            if ($('body').hasClass('fixed-sidebar')) {
              cov_th4vtqm2z.b[6][0]++;
              cov_th4vtqm2z.s[93]++;

              $('#side-menu').hide();
              cov_th4vtqm2z.s[94]++;
              setTimeout(function () {
                cov_th4vtqm2z.f[27]++;
                cov_th4vtqm2z.s[95]++;

                $('#side-menu').fadeIn(400);
              }, 100);
            } else {
              cov_th4vtqm2z.b[6][1]++;
              cov_th4vtqm2z.s[96]++;

              // Remove all inline style from jquery fadeIn function to reset menu state
              $('#side-menu').removeAttr('style');
            }
          }
      };
    }
  };
}

function closeOffCanvas() {
  cov_th4vtqm2z.f[28]++;
  cov_th4vtqm2z.s[97]++;

  return {
    restrict: 'A',
    template: '<a class="close-canvas-menu" ng-click="closeOffCanvas()"><i class="fa fa-times"></i></a>',
    controller: function controller($scope, $element) {
      cov_th4vtqm2z.s[98]++;

      $scope.closeOffCanvas = function () {
        cov_th4vtqm2z.f[29]++;
        cov_th4vtqm2z.s[99]++;

        $('body').toggleClass('mini-navbar');
      };
    }
  };
}

/**
 * vectorMap - Directive for Vector map plugin
 */
function vectorMap() {
  cov_th4vtqm2z.f[30]++;
  cov_th4vtqm2z.s[100]++;

  return {
    restrict: 'A',
    scope: {
      myMapData: '='
    },
    link: function link(scope, element, attrs) {
      var map = (cov_th4vtqm2z.s[101]++, element.vectorMap({
        map: 'world_mill_en',
        backgroundColor: 'transparent',
        regionStyle: {
          initial: {
            fill: '#e4e4e4',
            'fill-opacity': 0.9,
            stroke: 'none',
            'stroke-width': 0,
            'stroke-opacity': 0
          }
        },
        series: {
          regions: [{
            values: scope.myMapData,
            scale: ['#1ab394', '#22d6b1'],
            normalizeFunction: 'polynomial'
          }]
        }
      }));
      cov_th4vtqm2z.s[102]++;
      var destroyMap = function destroyMap() {
        cov_th4vtqm2z.f[31]++;
        cov_th4vtqm2z.s[103]++;

        element.remove();
      };
      cov_th4vtqm2z.s[104]++;
      scope.$on('$destroy', function () {
        cov_th4vtqm2z.f[32]++;
        cov_th4vtqm2z.s[105]++;

        destroyMap();
      });
    }
  };
}

/**
 * sparkline - Directive for Sparkline chart
 */
function sparkline() {
  cov_th4vtqm2z.f[33]++;
  cov_th4vtqm2z.s[106]++;

  return {
    restrict: 'A',
    scope: {
      sparkData: '=',
      sparkOptions: '='
    },
    link: function link(scope, element, attrs) {
      cov_th4vtqm2z.s[107]++;

      scope.$watch(scope.sparkData, function () {
        cov_th4vtqm2z.f[34]++;
        cov_th4vtqm2z.s[108]++;

        render();
      });
      cov_th4vtqm2z.s[109]++;
      scope.$watch(scope.sparkOptions, function () {
        cov_th4vtqm2z.f[35]++;
        cov_th4vtqm2z.s[110]++;

        render();
      });
      cov_th4vtqm2z.s[111]++;
      var render = function render() {
        cov_th4vtqm2z.f[36]++;
        cov_th4vtqm2z.s[112]++;

        $(element).sparkline(scope.sparkData, scope.sparkOptions);
      };
    }
  };
}

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
  cov_th4vtqm2z.f[37]++;
  cov_th4vtqm2z.s[113]++;

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link($scope, element, $attrs, ngModel) {
      cov_th4vtqm2z.s[114]++;

      return $timeout(function () {
        cov_th4vtqm2z.f[38]++;

        var value = (cov_th4vtqm2z.s[115]++, $attrs.value);

        cov_th4vtqm2z.s[116]++;
        $scope.$watch($attrs.ngModel, function (newValue) {
          cov_th4vtqm2z.f[39]++;
          cov_th4vtqm2z.s[117]++;

          $(element).iCheck('update');
        });

        cov_th4vtqm2z.s[118]++;
        return $(element).iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'iradio_square-green'

        }).on('ifChanged', function (event) {
          cov_th4vtqm2z.f[40]++;
          cov_th4vtqm2z.s[119]++;

          if ((cov_th4vtqm2z.b[8][0]++, $(element).attr('type') === 'checkbox') && (cov_th4vtqm2z.b[8][1]++, $attrs.ngModel)) {
            cov_th4vtqm2z.b[7][0]++;
            cov_th4vtqm2z.s[120]++;

            $scope.$apply(function () {
              cov_th4vtqm2z.f[41]++;
              cov_th4vtqm2z.s[121]++;

              return ngModel.$setViewValue(event.target.checked);
            });
          } else {
            cov_th4vtqm2z.b[7][1]++;
          }
          cov_th4vtqm2z.s[122]++;
          if ((cov_th4vtqm2z.b[10][0]++, $(element).attr('type') === 'radio') && (cov_th4vtqm2z.b[10][1]++, $attrs.ngModel)) {
            cov_th4vtqm2z.b[9][0]++;
            cov_th4vtqm2z.s[123]++;

            return $scope.$apply(function () {
              cov_th4vtqm2z.f[42]++;
              cov_th4vtqm2z.s[124]++;

              return ngModel.$setViewValue(value);
            });
          } else {
            cov_th4vtqm2z.b[9][1]++;
          }
        });
      });
    }
  };
}

/**
 * ionRangeSlider - Directive for Ion Range Slider
 */
function ionRangeSlider() {
  cov_th4vtqm2z.f[43]++;
  cov_th4vtqm2z.s[125]++;

  return {
    restrict: 'A',
    scope: {
      rangeOptions: '='
    },
    link: function link(scope, elem, attrs) {
      cov_th4vtqm2z.s[126]++;

      elem.ionRangeSlider(scope.rangeOptions);
    }
  };
}

/**
 * dropZone - Directive for Drag and drop zone file upload plugin
 */
function dropZone() {
  cov_th4vtqm2z.f[44]++;
  cov_th4vtqm2z.s[127]++;

  return {
    restrict: 'C',
    link: function link(scope, element, attrs) {
      var config = (cov_th4vtqm2z.s[128]++, {
        url: 'http://localhost:8080/upload',
        maxFilesize: 100,
        paramName: 'uploadfile',
        maxThumbnailFilesize: 10,
        parallelUploads: 1,
        autoProcessQueue: false
      });

      var eventHandlers = (cov_th4vtqm2z.s[129]++, {
        addedfile: function addedfile(file) {
          cov_th4vtqm2z.s[130]++;

          scope.file = file;
          cov_th4vtqm2z.s[131]++;
          if (this.files[1] != null) {
            cov_th4vtqm2z.b[11][0]++;
            cov_th4vtqm2z.s[132]++;

            this.removeFile(this.files[0]);
          } else {
            cov_th4vtqm2z.b[11][1]++;
          }
          cov_th4vtqm2z.s[133]++;
          scope.$apply(function () {
            cov_th4vtqm2z.f[45]++;
            cov_th4vtqm2z.s[134]++;

            scope.fileAdded = true;
          });
        },
        success: function success(file, response) {}
      });

      cov_th4vtqm2z.s[135]++;
      dropzone = new Dropzone(element[0], config);

      cov_th4vtqm2z.s[136]++;
      angular.forEach(eventHandlers, function (handler, event) {
        cov_th4vtqm2z.f[46]++;
        cov_th4vtqm2z.s[137]++;

        dropzone.on(event, handler);
      });

      cov_th4vtqm2z.s[138]++;
      scope.processDropzone = function () {
        cov_th4vtqm2z.f[47]++;
        cov_th4vtqm2z.s[139]++;

        dropzone.processQueue();
      };

      cov_th4vtqm2z.s[140]++;
      scope.resetDropzone = function () {
        cov_th4vtqm2z.f[48]++;
        cov_th4vtqm2z.s[141]++;

        dropzone.removeAllFiles();
      };
    }
  };
}

/**
 * chatSlimScroll - Directive for slim scroll for small chat
 */
function chatSlimScroll($timeout) {
  cov_th4vtqm2z.f[49]++;
  cov_th4vtqm2z.s[142]++;

  return {
    restrict: 'A',
    link: function link(scope, element) {
      cov_th4vtqm2z.s[143]++;

      $timeout(function () {
        cov_th4vtqm2z.f[50]++;
        cov_th4vtqm2z.s[144]++;

        element.slimscroll({
          height: '234px',
          railOpacity: 0.4
        });
      });
    }
  };
}

/**
 * customValid - Directive for custom validation example
 */
function customValid() {
  cov_th4vtqm2z.f[51]++;
  cov_th4vtqm2z.s[145]++;

  return {
    require: 'ngModel',
    link: function link(scope, ele, attrs, c) {
      cov_th4vtqm2z.s[146]++;

      scope.$watch(attrs.ngModel, function () {
        cov_th4vtqm2z.f[52]++;

        // You can call a $http method here
        // Or create custom validation

        var validText = (cov_th4vtqm2z.s[147]++, 'Inspinia');

        cov_th4vtqm2z.s[148]++;
        if (scope.extras == validText) {
          cov_th4vtqm2z.b[12][0]++;
          cov_th4vtqm2z.s[149]++;

          c.$setValidity('cvalid', true);
        } else {
          cov_th4vtqm2z.b[12][1]++;
          cov_th4vtqm2z.s[150]++;

          c.$setValidity('cvalid', false);
        }
      });
    }
  };
}

/**
 * fullScroll - Directive for slimScroll with 100%
 */
function fullScroll($timeout) {
  cov_th4vtqm2z.f[53]++;
  cov_th4vtqm2z.s[151]++;

  return {
    restrict: 'A',
    link: function link(scope, element) {
      cov_th4vtqm2z.s[152]++;

      $timeout(function () {
        cov_th4vtqm2z.f[54]++;
        cov_th4vtqm2z.s[153]++;

        element.slimscroll({
          height: '100%',
          railOpacity: 0.9
        });
      });
    }
  };
}

/**
 * slimScroll - Directive for slimScroll with custom height
 */
function slimScroll($timeout) {
  cov_th4vtqm2z.f[55]++;
  cov_th4vtqm2z.s[154]++;

  return {
    restrict: 'A',
    scope: {
      boxHeight: '@'
    },
    link: function link(scope, element) {
      cov_th4vtqm2z.s[155]++;

      $timeout(function () {
        cov_th4vtqm2z.f[56]++;
        cov_th4vtqm2z.s[156]++;

        element.slimscroll({
          height: scope.boxHeight,
          railOpacity: 0.9
        });
      });
    }
  };
}

/**
 * slimScrollFull - Directive for slimScroll with full height
 */
function slimScrollFull($timeout) {
  cov_th4vtqm2z.f[57]++;
  cov_th4vtqm2z.s[157]++;

  return {
    restrict: 'A',
    scope: {
      boxItem: '@'
    },
    link: function link(scope, element) {
      cov_th4vtqm2z.s[158]++;

      $timeout(function () {
        cov_th4vtqm2z.f[58]++;

        var wrapper = (cov_th4vtqm2z.s[159]++, 'wrapper');
        var ele = (cov_th4vtqm2z.s[160]++, $('#' + scope.boxItem));
        var top = (cov_th4vtqm2z.s[161]++, ele.position().top);
        var i = (cov_th4vtqm2z.s[162]++, 0);
        cov_th4vtqm2z.s[163]++;
        while (true) {
          cov_th4vtqm2z.s[164]++;

          i++;
          var par = (cov_th4vtqm2z.s[165]++, ele.parent());
          cov_th4vtqm2z.s[166]++;
          if (!par) {
            cov_th4vtqm2z.b[13][0]++;
            cov_th4vtqm2z.s[167]++;

            break;
          } else {
            cov_th4vtqm2z.b[13][1]++;
          }
          // console.log(par.attr("id"));
          cov_th4vtqm2z.s[168]++;
          if (par.attr('id') == wrapper) {
            cov_th4vtqm2z.b[14][0]++;
            cov_th4vtqm2z.s[169]++;

            break;
          } else {
            cov_th4vtqm2z.b[14][1]++;
          }
          cov_th4vtqm2z.s[170]++;
          ele = par;
          cov_th4vtqm2z.s[171]++;
          top += ele.position().top;
        }
        var length = (cov_th4vtqm2z.s[172]++, $(window).height() - top - $('#delta-footer').height());
        cov_th4vtqm2z.s[173]++;
        element.slimscroll({
          height: length,
          railOpacity: 0.9
        });
      });
    }
  };
}

/**
 * slimScroll - Directive for slimScroll with custom height
 */
function slimScrollAfter($timeout) {
  cov_th4vtqm2z.f[59]++;
  cov_th4vtqm2z.s[174]++;

  return {
    restrict: 'A',
    scope: {
      lastEl: '@',
      addHeight: '@'
    },
    link: function link(scope, element) {
      cov_th4vtqm2z.s[175]++;

      // Enable initial fixed sidebar
      $timeout(function () {
        cov_th4vtqm2z.f[60]++;

        var position = (cov_th4vtqm2z.s[176]++, element.position());
        var sidebar = (cov_th4vtqm2z.s[177]++, element.parent());
        cov_th4vtqm2z.s[178]++;
        element.slimScroll({
          height: $(window).height() - (position.top + 55) /* +scope.addHeight */
          , railOpacity: 0.9
        });
      });
    }
  };
}
/**
 * clockPicker - Directive for clock picker plugin
 */
function clockPicker() {
  cov_th4vtqm2z.f[61]++;
  cov_th4vtqm2z.s[179]++;

  return {
    restrict: 'A',
    link: function link(scope, element) {
      cov_th4vtqm2z.s[180]++;

      element.clockpicker();
    }
  };
}

/**
 * landingScrollspy - Directive for scrollspy in landing page
 */
function landingScrollspy() {
  cov_th4vtqm2z.f[62]++;
  cov_th4vtqm2z.s[181]++;

  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      cov_th4vtqm2z.s[182]++;

      element.scrollspy({
        target: '.navbar-fixed-top',
        offset: 80
      });
    }
  };
}

/**
 * fitHeight - Directive for set height fit to window height
 */
function fitHeight() {
  cov_th4vtqm2z.f[63]++;
  cov_th4vtqm2z.s[183]++;

  return {
    restrict: 'A',
    link: function link(scope, element) {
      cov_th4vtqm2z.s[184]++;

      element.css('height', $(window).height() + 'px');
      cov_th4vtqm2z.s[185]++;
      element.css('min-height', $(window).height() + 'px');
    }
  };
}

/**
 * truncate - Directive for truncate string
 */
function truncate($timeout) {
  cov_th4vtqm2z.f[64]++;
  cov_th4vtqm2z.s[186]++;

  return {
    restrict: 'A',
    scope: {
      truncateOptions: '='
    },
    link: function link(scope, element) {
      cov_th4vtqm2z.s[187]++;

      $timeout(function () {
        cov_th4vtqm2z.f[65]++;
        cov_th4vtqm2z.s[188]++;

        element.dotdotdot(scope.truncateOptions);
      });
    }
  };
}

/**
 * touchSpin - Directive for Bootstrap TouchSpin
 */
function touchSpin() {
  cov_th4vtqm2z.f[66]++;
  cov_th4vtqm2z.s[189]++;

  return {
    restrict: 'A',
    scope: {
      spinOptions: '='
    },
    link: function link(scope, element, attrs) {
      cov_th4vtqm2z.s[190]++;

      scope.$watch(scope.spinOptions, function () {
        cov_th4vtqm2z.f[67]++;
        cov_th4vtqm2z.s[191]++;

        render();
      });
      cov_th4vtqm2z.s[192]++;
      var render = function render() {
        cov_th4vtqm2z.f[68]++;
        cov_th4vtqm2z.s[193]++;

        $(element).TouchSpin(scope.spinOptions);
      };
    }
  };
}

/**
 * markdownEditor - Directive for Bootstrap Markdown
 */
function markdownEditor() {
  cov_th4vtqm2z.f[69]++;
  cov_th4vtqm2z.s[194]++;

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      cov_th4vtqm2z.s[195]++;

      $(element).markdown({
        savable: false,
        onChange: function onChange(e) {
          cov_th4vtqm2z.s[196]++;

          ngModel.$setViewValue(e.getContent());
        }
      });
    }
  };
}

/**
 * Upload File f
 */
function fileModel($parse) {
  cov_th4vtqm2z.f[70]++;
  cov_th4vtqm2z.s[197]++;

  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var model = (cov_th4vtqm2z.s[198]++, $parse(attrs.fileModel));
      var modelSetter = (cov_th4vtqm2z.s[199]++, model.assign);
      cov_th4vtqm2z.s[200]++;
      element.bind('change', function () {
        cov_th4vtqm2z.f[71]++;
        cov_th4vtqm2z.s[201]++;

        scope.$apply(function () {
          cov_th4vtqm2z.f[72]++;
          cov_th4vtqm2z.s[202]++;

          if (element[0].files[0]) {
            cov_th4vtqm2z.b[15][0]++;
            cov_th4vtqm2z.s[203]++;

            modelSetter(scope, element[0].files[0]);
          } else {
            cov_th4vtqm2z.b[15][1]++;
          }
        });
      });
    }
  };
}
/**
 *
 * Pass all functions into module
 */
cov_th4vtqm2z.s[204]++;
angular.module('app').directive('pageTitle', pageTitle).directive('sideNavigation', sideNavigation).directive('iboxTools', iboxTools).directive('minimalizaSidebar', minimalizaSidebar).directive('vectorMap', vectorMap).directive('sparkline', sparkline).directive('icheck', icheck).directive('ionRangeSlider', ionRangeSlider).directive('dropZone', dropZone).directive('responsiveVideo', responsiveVideo).directive('chatSlimScroll', chatSlimScroll).directive('customValid', customValid).directive('fullScroll', fullScroll).directive('closeOffCanvas', closeOffCanvas).directive('clockPicker', clockPicker).directive('landingScrollspy', landingScrollspy).directive('fitHeight', fitHeight).directive('iboxToolsFullScreen', iboxToolsFullScreen).directive('iboxToolsFullScreenOnly', iboxToolsFullScreenOnly).directive('slimScroll', slimScroll).directive('slimScrollFull', slimScrollFull).directive('slimScrollAfter', slimScrollAfter).directive('truncate', truncate).directive('touchSpin', touchSpin).directive('fileModel', fileModel).directive('iboxCollapsable', iboxCollapsable).directive('markdownEditor', markdownEditor);